<template>
  <gg-modal :is-active="isActive" @close="closeModal">
    <template v-slot:toolbar>Delete autoresponder</template>
    <template v-slot:body class="text-center">
      Are you sure you want to delete the autoresponder
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="closeModal">
        Cancel
      </gg-btn>
      <gg-btn primary :loading="loading" @click="removeResponder">
        Delete
      </gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'DeleteModal',
  data: () => ({
    loading: false
  }),
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    email: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions({
      deleteResponder: 'email/deleteResponder',
      setRespondersDomain: 'email/setRespondersDomain',
      reportError: 'reportError',
      reportSuccess: 'reportSuccess'
    }),
    async removeResponder () {
      try {
        this.loading = true
        const data = {
          uapi_module: 'Email',
          uapi_function: 'delete_auto_responder',
          email: this.email,
          _username: this.$route.query.user,
        }
        await this.deleteResponder(data)
        this.closeModal()
        this.reportSuccess('Autoresponder was successfully deleted')
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
    closeModal () {
      this.$emit('close')
    },
    actionCompleted () {
      this.$emit('action-completed')
    }
  }
}
</script>
